import RemoveIcon from "@mui/icons-material/Remove";
import React from "react";
import { DataFormControl } from "../DataFormControl";
import { IDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/IDataDefinition";
import { StringDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/StringDataDefinition";
import { DataUtilities } from "../../../rule-engine-core/Common/DataUtilities";
import { StateManager } from "../../../rule-engine-core/Common/StateManager";
import { UIStyleConstants } from "../../../rule-engine-core/Common/UIStyleConstants";
import { Button, IconButton, List, ListItem, ListItemSecondaryAction, ListItemText, TextField } from "@mui/material";
import { UISpacedBoxContent } from "../../../CommonUI/BuildlingBlocks/UISpacedBoxContent";
import { UIToggleButtons } from "../../../CommonUI/BuildlingBlocks/UIToggleButtons";

class XButtonGroupEditUI extends React.Component<{ editMe: ButtonGroupFormControl }> {
    render() {
        return (
            <UISpacedBoxContent>
                <TextField
                    label="Content Text"
                    value={this.props.editMe.label}
                    onChange={(event) => {
                        this.props.editMe.label = event.target.value;
                        StateManager.changed(this.props.editMe);
                    }}
                />
                <TextField
                    label="Value Name"
                    value={this.props.editMe.valueName}
                    onChange={(event) => {
                        this.props.editMe.valueName = event.target.value;
                        StateManager.changed(this.props.editMe);
                    }}
                />
                <List style={{ width: "100%" }}>
                    {this.props.editMe.list.map((s: string, idx: number) => (
                        <ListItem>
                            <ListItemText>
                                <TextField
                                    label="Button Label"
                                    value={s}
                                    size="small"
                                    onChange={(event) => {
                                        this.props.editMe.list[idx] = event.target.value;
                                        StateManager.changed(this.props.editMe);
                                    }}
                                    key={idx}
                                />
                            </ListItemText>
                            <ListItemSecondaryAction>
                                <IconButton
                                    color="secondary"
                                    size="small"
                                    onClick={() => {
                                        this.props.editMe.list.splice(idx, 1);
                                        StateManager.changed(this.props.editMe);
                                    }}
                                >
                                    <RemoveIcon />
                                </IconButton>
                            </ListItemSecondaryAction>
                        </ListItem>
                    ))}
                </List>
                <Button
                    sx={{ background: UIStyleConstants.BLUE_COLOR }}
                    onClick={() => {
                        this.props.editMe.list.push("");
                        StateManager.changed(this.props.editMe);
                    }}
                >
                    {" "}
                    Add Button{" "}
                </Button>
            </UISpacedBoxContent>
        );
    }
}

export class ButtonGroupFormControl extends DataFormControl {
    readonly __type: string = "Button Group";
    label: string = "buttonGroupLabel";
    valueName: string = "buttonGroupValue";
    list: string[] = [];

    // needs validation
    render() {
        let items = this.list;

        if (!items || items.length === 0) {
            items = ["needs configuration", "please setup"];
        }

        return (
            <UIToggleButtons
                label={this.label}
                onChange={this.handleChange}
                value={this.valueName ? this.getFormDataValue(this.valueName) : ""}
                options={items}
            ></UIToggleButtons>
        );
    }

    handleChange = (newValue: string | undefined) => {
        if (this.valueName) {
            this.setFormDataValue(this.valueName, newValue);
        }
    };

    renderEditUI(): JSX.Element | null {
        return <XButtonGroupEditUI editMe={this} />;
    }

    getAddedData(): IDataDefinition | IDataDefinition[] | undefined {
        if (!this.valueName) return;

        let def = new StringDataDefinition();
        def.name = this.valueName;
        return def;
    }

    getStorageData(): object {
        let retData = super.getStorageData();

        retData = DataUtilities.addStorageData(this, retData, "__type", "readonly", "label", "valueName", "list");

        return retData;
    }

    setStorageData(data: object): void {
        super.setStorageData(data);

        DataUtilities.setStorageData(this, data, "__type", "readonly", "label", "valueName", "list");
    }
}
